export default __webpack_public_path__ + "static/media/gallery-wip-ammo-port-enclosure-box_01.6fd810c2.jpg";